var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex", style: _vm.isInDingTalk ? "height:80vh" : "" },
    [
      _c(
        "div",
        { staticClass: "left-menu" },
        [
          _c(
            "el-menu",
            {
              attrs: {
                router: "",
                "default-active": _vm.computedPath,
                "active-text-color": "#ec1c1c"
              },
              on: { open: _vm.handleOpen }
            },
            _vm._l(_vm.docMenus, function(meun, i) {
              return _c(
                "el-menu-item",
                { key: i, attrs: { index: meun.url } },
                [
                  _c("i", {
                    class: meun.icon,
                    staticStyle: {
                      color: "#a4bbe7",
                      width: "18px",
                      height: "18px"
                    }
                  }),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v(_vm._s(meun.name))
                  ])
                ]
              )
            }),
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "view" }, [_c("nuxt-child")], 1)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-489996b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-489996b0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/smartDoc.vue
// module id = BoTT
// module chunks = 208